import { watch } from 'vue-demi';
<template>
    <div class="site-item" @click="handleClick">
        <div class="site-name">
            <span>{{ data.name }}</span>
            <el-tag size="mini" class="tag-stutas" :color="data.openStatus === 1 ? '#FF6A0060' : '#51799E60'"
                :class="data.openStatus === 1 ? 'border-1' : 'border-2'">
                {{ data.openStatusLabel }}</el-tag>
        </div>
        <div class="info-item">
            <span class="info-item__label">{{ $t('wuliu.index.businessHours') }}</span>
            <span style="display: inline-block;">
                <span>{{ data.openTime }}</span>
                <span>-</span>
                <span>{{ data.closeTime }}</span>
            </span>
        </div>
        <div class="takeout-main">
            <div class="info-item" v-for="item in statisticsData" :key="item.code">
                <span class="info-item__label">{{ item.name }}</span>
                <span class="info-item__number">{{ item.value }}</span>
            </div>
        </div>
    </div>

</template>

<script>
import Speed from '../../../../consolePage/components/aircraftcomponents/Speed.vue';

export default {
    name: 'SiteItem',
    components: { Speed },
    props: {
        data: {
            type: Object,
            default: () => { },
        },
        statisticsInfo: {
            type: Object,
            default: () => { },
        },
    },

    data () {
        return {};
    },
    watch: {
        data: {
            handler (newVal) {
                console.log('data changed', newVal);
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        statisticsData () {
            let list = [];
            console.log('this.statisticsInfo', this.statisticsInfo);

            if (this.statisticsInfo) {
                let takeoutOrderData = this.statisticsInfo.takeoutOrderData || {};
                let statusCount = takeoutOrderData.statusCount || [];
                list = statusCount.filter((item) => {
                    let code = Number(item.code);
                    return code <= 2;
                });
            }
            console.log('statisticsData', list);

            return list;
        },
    },
    methods: {
        handleClick () {
            this.$emit('click', this.data);
        },
    },
    mounted () {
        // console.log(this.data);
    },
};
</script>

<style lang="scss" scoped>
$bgColor: #0D1541;
$bgColor2: #0D134F;
$colorLight: #5bf0fc;
$borderColor: #2e355b;
$hoverBgColor: rgba(91, 240, 252, 0.1);

.site-item {
    padding: 12px;
    // border-bottom: 1px solid #0b1b86;
    border-bottom: 1px solid $borderColor;
    margin: 8px 10px;

    &:hover {
        background-color: hoverBgColor;
    }

    ::v-deep {
        .el-tag {
            &--mini {
                line-height: 1.5;
            }

        }
    }

    .site-name {
        font-size: 16px;
        color: $colorLight;
        font-weight: bold;
        display: flex;
        line-height: 26px;

        .tag-stutas {
            color: #ffffff !important;
            border-radius: 2px;
            height: 24px;
            line-height: 22px;
            margin-left: 10px;
        }
    }

    .site-cell {
        font-size: 12px;
    }

    .takeout-main {
        display: flex;
        flex-wrap: wrap
    }

    .info-item {
        line-height: 1.5;
        font-size: 14px;
        min-width: 50%;
        &__label {
            width: 60px;
            display: inline-block;
            color: #D0D0D0;
            margin-right: 8px;
            /* 文字两端对齐（针对多字标签） */
            // text-align-last: justify;
        }

        &__number {
            color: rgba(255, 255, 255, 1);

        }
    }
}

.border-1 {
    border: 1px solid #FF6A00;
}

.border-2 {
    border: 1px solid #51799E;
}
</style>
